import React from "react";
import logo from '../../img/kOnzy.gif';

export default function Button({ handleSubmit='',className, name="",type,email="",password="",text,loading}) {

    return (
        <button onClick={handleSubmit} 
        type={type} className={className}
        disabled={name && !name || (email && !email) || (email && !email.includes("@")) || (email && email.length < 6 ) || (password&&password.length < 6)}
        > { loading ? (<img src={logo} alt="loading" style={{height:"20px"}}/>): (text)}
        
        </button>
        
       
    )

} 
